import { Reducer } from 'redux';

import { localLimitState, localLimitTypes } from './types';

const INITIAL_STATE: localLimitState = {
  localLimit: 10,
};

const reducer: Reducer<localLimitState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES SET_LOCAL_STORAGE_LIMIT
    case localLimitTypes.SET_LOCAL_STORAGE_LIMIT:
      return {
        ...state,
        localLimit: action.payload.limit,
      };

    default:
      return state;
  }
};

export default reducer;
